import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from "@mui/material";
import { Close } from "@mui/icons-material";

import Button from "../Button";
import Slide from "@mui/material/Slide";
import "./ModalDrawer.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const ModalDrawer = ({
  open,
  handleClose,
  title,
  isContentText,
  content,
  hasActions,
  confirmBtnTxt,
  cancelBtnTxt,
  handleConfirm,
  handleCancel,
  showCloseIcon,
  maxWidth,
  scrollMode,
  modalClass,
  titleClass,
  contentClass,
  actionsClass,
  confirmBtnClass,
  cancelBtnClass,
  disableEscapeKeyDown,
  disableBackdropClick,
  alignBtnsCenter,
  disableConfirmBtn,
  isLoading
}) => {
  const lang = useSelector((state) => state.locale.lang);

  const onClose = (event, reason) => {
    if (reason === "backdropClick" && disableBackdropClick) {
      return;
    }
    handleClose(false);
  };
  return (
    <Dialog
      TransitionComponent={Transition}
      keepMounted
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={true}
      scroll={scrollMode}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`${modalClass} drawer-modal`}
      disableEscapeKeyDown={disableEscapeKeyDown}>
      {title && (
        <DialogTitle
          id="alert-dialog-title"
          className={`${titleClass} px-4`}>
          {title}
          {showCloseIcon && (
            <IconButton
              aria-label="close"
              onClick={() => handleClose(false)}
              sx={
                lang === "en"
                  ? {
                      position: "absolute",
                      top: 8,
                      right: 8
                    }
                  : {
                      position: "absolute",
                      top: 8,
                      left: 8
                    }
              }>
              <Close />
            </IconButton>
          )}
        </DialogTitle>
      )}
      {content && (
        <DialogContent
          id="alert-dialog-description"
          className={contentClass}>
          {isContentText ? (
            <DialogContentText>{content}</DialogContentText>
          ) : (
            <>{content}</>
          )}
        </DialogContent>
      )}
      {hasActions && (
        <DialogActions
          className={`container mb-4 d-flex align-items-center ${actionsClass} ${
            alignBtnsCenter
              ? "justify-content-center"
              : "justify-content-end"
          }`}>
          {cancelBtnTxt && (
            <Button
              label={cancelBtnTxt}
              outlined
              onClick={handleCancel}
              className={`${cancelBtnClass} mx-2 fsize-14 px-4`}
              disabled={isLoading}
            />
          )}
          {confirmBtnTxt && (
            <Button
              label={confirmBtnTxt}
              onClick={handleConfirm}
              className={`${confirmBtnClass} fsize-14 text-white px-4`}
              disabled={disableConfirmBtn || isLoading}
            />
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

ModalDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isContentText: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  hasActions: PropTypes.bool,
  confirmBtnTxt: PropTypes.string,
  cancelBtnTxt: PropTypes.string,
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  scrollMode: PropTypes.oneOf(["paper", "body"]),
  modalClass: PropTypes.string,
  titleClass: PropTypes.string,
  contentClass: PropTypes.string,
  actionsClass: PropTypes.string,
  confirmBtnClass: PropTypes.string,
  cancelBtnClass: PropTypes.string,
  disableEscapeKeyDown: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  alignBtnsCenter: PropTypes.bool,
  disableConfirmBtn: PropTypes.bool,
  isLoading: PropTypes.bool
};

ModalDrawer.defaultProps = {
  isContentText: true,
  hasActions: true,
  showCloseIcon: true,
  maxWidth: "sm",
  scrollMode: "paper",
  alignBtnsCenter: true
};

export default ModalDrawer;
